import React from 'react';
import { XCircle, CheckCircle2 } from 'lucide-react';
import { FadeIn } from './ui/FadeIn';
const withoutSystem = ['Comidas improvisadas', 'Inflamación frecuente', 'Falta de energía', 'Estrés con las comidas', 'Mala organización', 'Dieta aburrida', 'Riesgo de contaminación cruzada'];
const withSystem = ['Alimentación organizada', 'Más energía', 'Recetas fáciles', 'Menos estrés', 'Mejor digestión', 'Hábitos saludables', 'Más tranquilidad diaria'];
export function Comparison() {
  return <section className="py-24 bg-white" data-id="element-30">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-31">
        <div className="text-center max-w-3xl mx-auto mb-16" data-id="element-32">
          <FadeIn data-id="element-33">
            <h2 className="text-sm font-bold tracking-widest text-brand-600 uppercase mb-3" data-id="element-34">
              LA REALIDAD
            </h2>
            <p className="text-3xl md:text-4xl font-serif font-bold text-brand-950" data-id="element-35">
              ¿Qué pasa cuando no organizás tu alimentación?
            </p>
          </FadeIn>
        </div>

        <div className="grid md:grid-cols-2 gap-8 max-w-5xl mx-auto" data-id="element-36">
          {/* Without System */}
          <FadeIn delay={0.1} className="bg-red-50/50 rounded-[2rem] p-8 md:p-10 border border-red-100" data-id="element-37">
            <h3 className="text-2xl font-bold text-red-900 mb-8 text-center" data-id="element-38">
              Sin el sistema
            </h3>
            <ul className="space-y-5" data-id="element-39">
              {withoutSystem.map((item, idx) => <li key={idx} className="flex items-center gap-4" data-id="element-40">
                  <XCircle className="w-6 h-6 text-red-400 flex-shrink-0" data-id="element-41" />
                  <span className="text-red-900/80 font-medium text-lg" data-id="element-42">
                    {item}
                  </span>
                </li>)}
            </ul>
          </FadeIn>

          {/* With System */}
          <FadeIn delay={0.2} className="bg-brand-50 rounded-[2rem] p-8 md:p-10 border border-brand-100 shadow-soft-lg relative overflow-hidden" data-id="element-43">
            <div className="absolute top-0 right-0 w-32 h-32 bg-brand-100 rounded-full blur-3xl -mr-16 -mt-16" data-id="element-44"></div>
            <h3 className="text-2xl font-bold text-brand-900 mb-8 text-center relative z-10" data-id="element-45">
              Con el sistema
            </h3>
            <ul className="space-y-5 relative z-10" data-id="element-46">
              {withSystem.map((item, idx) => <li key={idx} className="flex items-center gap-4" data-id="element-47">
                  <CheckCircle2 className="w-6 h-6 text-brand-500 flex-shrink-0" data-id="element-48" />
                  <span className="text-brand-900 font-bold text-lg" data-id="element-49">
                    {item}
                  </span>
                </li>)}
            </ul>
          </FadeIn>
        </div>
      </div>
    </section>;
}